import { render, staticRenderFns } from "./AddThirdPartyOccupant.vue?vue&type=template&id=d041f5d0"
import script from "./AddThirdPartyOccupant.vue?vue&type=script&lang=js"
export * from "./AddThirdPartyOccupant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports